import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = { class: "input" }
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_7 = { class: "user-modal-content" }
const _hoisted_8 = { class: "modalcontent" }
const _hoisted_9 = { class: "modalcontent__h2" }
const _hoisted_10 = { class: "modalcontent__margin user-modalcontent__margin" }
const _hoisted_11 = { class: "modalcontent__text-info" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "necessarily" }, "*", -1)
const _hoisted_13 = { value: "Admin" }
const _hoisted_14 = { value: "Guide" }
const _hoisted_15 = { value: "Content-Manager" }
const _hoisted_16 = { class: "modalcontent__text-info" }
const _hoisted_17 = { class: "modalcontent__text-info" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "necessarily" }, "*", -1)
const _hoisted_19 = { class: "user-create-passwords" }
const _hoisted_20 = { class: "create-user-modal" }
const _hoisted_21 = { class: "modalcontent__text-info" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "necessarily" }, "*", -1)
const _hoisted_23 = { class: "create-user-modal" }
const _hoisted_24 = { class: "modalcontent__text-info" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", { class: "necessarily" }, "*", -1)
const _hoisted_26 = { class: "buttons justifay-content-center" }
const _hoisted_27 = {
  class: "button-using",
  type: "submit"
}
const _hoisted_28 = { class: "container" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "user-table" }
const _hoisted_32 = /*#__PURE__*/_createVNode("th", null, "#", -1)
const _hoisted_33 = { class: "user-id" }
const _hoisted_34 = { class: "user-first-name" }
const _hoisted_35 = { class: "user-email" }
const _hoisted_36 = { class: "user-roles" }
const _hoisted_37 = { class: "user-edit" }
const _hoisted_38 = { class: "container" }
const _hoisted_39 = { class: "row justify-content-end" }
const _hoisted_40 = { class: "col-4 section__link-content-end" }
const _hoisted_41 = { class: "pagination" }
const _hoisted_42 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_43 = { class: "modal-content" }
const _hoisted_44 = { class: "modalcontent" }
const _hoisted_45 = { class: "modalcontent__h2" }
const _hoisted_46 = { class: "modalcontent__margin modalcontent__margin-faq" }
const _hoisted_47 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = { class: "modalcontent" }
const _hoisted_50 = { class: "modalcontent__h2" }
const _hoisted_51 = { class: "modalcontent__margin modalcontent__margin__change" }
const _hoisted_52 = { class: "modalcontent__text-info" }
const _hoisted_53 = { class: "modalcontent__text-info" }
const _hoisted_54 = { value: "Admin" }
const _hoisted_55 = { value: "Guide" }
const _hoisted_56 = { value: "Content-Manager" }
const _hoisted_57 = { class: "modalcontent__margin modalcontent__margin-faq" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_main_footer = _resolveComponent("main-footer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _withDirectives(_createVNode("input", {
              type: "text",
              name: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.data.search = $event)),
              placeholder: "ID, Почта, Имя",
              class: "search-input",
              onKeyup: _cache[2] || (_cache[2] = (...args) => (_ctx.endAndStartTimer(...args)))
            }, null, 544), [
              [_vModelText, _ctx.data.search]
            ]),
            _createVNode(_component_svg_icon, { name: "Combined_Shape" })
          ])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("button", {
            class: "button-using button-using-create-user",
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.active = !_ctx.active))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('admin.createUser')) + " ", 1 /* TEXT */),
            _createVNode(_component_svg_icon, { name: "Vector" })
          ]),
          _createVNode(_Transition, { name: "slide-fade" }, {
            default: _withCtx(() => [
              (_ctx.active)
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode("form", {
                      onSubmit: _cache[11] || (_cache[11] = _withModifiers((...args) => (_ctx.createUser(...args)), ["prevent"])),
                      class: "form login__form",
                      method: "POST"
                    }, [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("span", {
                          class: "close user-create-close",
                          onClick: _cache[4] || (_cache[4] = $event => (_ctx.active = !_ctx.active))
                        }, "×"),
                        _createVNode("div", _hoisted_8, [
                          _createVNode("h2", _hoisted_9, _toDisplayString(_ctx.$t('admin.createUser')), 1),
                          _createVNode("div", _hoisted_10, [
                            _createVNode("p", _hoisted_11, [
                              _createTextVNode(_toDisplayString(_ctx.$t('admin.role')) + " ", 1 /* TEXT */),
                              _hoisted_12
                            ]),
                            _withDirectives(_createVNode("select", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.data.role = $event)),
                              id: "role",
                              name: "role",
                              class: "modalcontent__input user-modalcontent__input"
                            }, [
                              _createVNode("option", _hoisted_13, _toDisplayString(_ctx.$t('admin.admin')), 1),
                              _createVNode("option", _hoisted_14, _toDisplayString(_ctx.$t('admin.guide')), 1),
                              _createVNode("option", _hoisted_15, _toDisplayString(_ctx.$t('admin.content_manger')), 1)
                            ], 512), [
                              [_vModelSelect, _ctx.data.role]
                            ]),
                            _createVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('admin.fullName')), 1),
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "modalcontent__input user-modalcontent__input",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.data.fullname = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.data.fullname]
                            ]),
                            _createVNode("p", _hoisted_17, [
                              _createTextVNode(_toDisplayString(_ctx.$t('admin.mail')) + " ", 1 /* TEXT */),
                              _hoisted_18
                            ]),
                            _withDirectives(_createVNode("input", {
                              type: "text",
                              class: "modalcontent__input user-modalcontent__input",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.data.email = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.data.email]
                            ]),
                            _createVNode("div", _hoisted_19, [
                              _createVNode("div", _hoisted_20, [
                                _createVNode("p", _hoisted_21, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('admin.pwd')) + " ", 1 /* TEXT */),
                                  _hoisted_22
                                ]),
                                _withDirectives(_createVNode("input", {
                                  type: "password",
                                  class: "modalcontent__input user-modalcontent__input create-modalcontent__input",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (_ctx.data.password = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.data.password]
                                ])
                              ]),
                              _createVNode("div", _hoisted_23, [
                                _createVNode("p", _hoisted_24, [
                                  _createTextVNode(_toDisplayString(_ctx.$t('admin.confirmPwd')) + " ", 1 /* TEXT */),
                                  _hoisted_25
                                ]),
                                _withDirectives(_createVNode("input", {
                                  type: "password",
                                  class: "modalcontent__input user-modalcontent__input create-modalcontent__input",
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (_ctx.data.password_repl = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.data.password_repl]
                                ])
                              ])
                            ]),
                            _createVNode("div", _hoisted_26, [
                              _createVNode("button", _hoisted_27, _toDisplayString(_ctx.$t('profile.save')), 1),
                              _createVNode("button", {
                                class: "create-user-button",
                                onClick: _cache[10] || (_cache[10] = $event => (_ctx.active = !_ctx.active))
                              }, _toDisplayString(_ctx.$t('profile.cancel')), 1)
                            ])
                          ])
                        ])
                      ])
                    ], 32)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_28, [
      _createVNode("div", _hoisted_29, [
        _createVNode("div", _hoisted_30, [
          _createVNode("table", _hoisted_31, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _hoisted_32,
                _createVNode("th", null, _toDisplayString(_ctx.$t('admin.name')), 1),
                _createVNode("th", null, _toDisplayString(_ctx.$t('admin.mail')), 1),
                _createVNode("th", null, _toDisplayString(_ctx.$t('admin.role')), 1),
                _createVNode("th", null, _toDisplayString(_ctx.$t('admin.operation')), 1)
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                return (_openBlock(), _createBlock("tr", {
                  key: user.id
                }, [
                  _createVNode("td", _hoisted_33, _toDisplayString(user.id), 1),
                  _createVNode("td", _hoisted_34, _toDisplayString(user.first_name), 1),
                  _createVNode("td", _hoisted_35, _toDisplayString(user.email), 1),
                  _createVNode("td", _hoisted_36, _toDisplayString(user.roles), 1),
                  _createVNode("td", null, [
                    _createVNode("div", _hoisted_37, [
                      _createVNode("button", {
                        class: "news-edit",
                        onClick: $event => {
                      ;(_ctx.changeactive1 = !_ctx.changeactive1),
                        (_ctx.user1 = user.id),
                        (_ctx.userinfo = user.email),
                        _ctx.selectUserRole(user.roles)
                    }
                      }, [
                        _createVNode(_component_svg_icon, { name: "Group_98" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('admin.change')), 1 /* TEXT */)
                      ], 8, ["onClick"]),
                      _createVNode("button", {
                        class: "news-delete",
                        onClick: $event => {;(_ctx.changeactive = !_ctx.changeactive), (_ctx.user1 = user.id)}
                      }, [
                        _createVNode(_component_svg_icon, { name: "delete" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('admin.delete')), 1 /* TEXT */)
                      ], 8, ["onClick"])
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_38, [
      _createVNode("div", _hoisted_39, [
        _createVNode("div", _hoisted_40, [
          _createVNode("ul", _hoisted_41, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userPage, (page) => {
              return (_openBlock(), _createBlock("li", {
                class: { ['page-active']: page.active },
                key: page.id,
                onClick: $event => (_ctx.pageUser(page.url))
              }, [
                _createVNode("p", {
                  innerHTML: page.label
                }, null, 8, ["innerHTML"])
              ], 10, ["onClick"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ]),
    _createVNode(_component_main_footer),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.changeactive)
          ? (_openBlock(), _createBlock("div", _hoisted_42, [
              _createVNode("div", _hoisted_43, [
                _createVNode("span", {
                  class: "close admin-change-close",
                  onClick: _cache[12] || (_cache[12] = $event => (_ctx.changeactive = !_ctx.changeactive))
                }, "×"),
                _createVNode("div", _hoisted_44, [
                  _createVNode("h2", _hoisted_45, _toDisplayString(_ctx.$t('panelAdminFaq.reallyWantMessage')), 1),
                  _createVNode("div", _hoisted_46, [
                    _createVNode("button", {
                      class: "button button--primary form__button form__button1",
                      onClick: _cache[13] || (_cache[13] = $event => (_ctx.removeUserById(_ctx.user1)))
                    }, _toDisplayString(_ctx.$t('admin.yes')), 1),
                    _createVNode("button", {
                      class: "button button--primary form__button form__button1",
                      onClick: _cache[14] || (_cache[14] = $event => (_ctx.changeactive = !_ctx.changeactive))
                    }, _toDisplayString(_ctx.$t('admin.no')), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.changeactive1)
          ? (_openBlock(), _createBlock("div", _hoisted_47, [
              _createVNode("div", _hoisted_48, [
                _createVNode("span", {
                  class: "close admin-change-close",
                  onClick: _cache[15] || (_cache[15] = $event => (_ctx.changeactive1 = !_ctx.changeactive1))
                }, "×"),
                _createVNode("div", _hoisted_49, [
                  _createVNode("h2", _hoisted_50, _toDisplayString(_ctx.$t('panelAdminFaq.editData')), 1),
                  _createVNode("div", _hoisted_51, [
                    _createVNode("p", _hoisted_52, _toDisplayString(_ctx.$t('admin.mail')), 1),
                    _withDirectives(_createVNode("input", {
                      disabled: "",
                      type: "text",
                      class: "modalcontent__input user-modalcontent__input",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (_ctx.userinfo = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.userinfo]
                    ]),
                    _createVNode("p", _hoisted_53, _toDisplayString(_ctx.$t('admin.role')), 1),
                    _withDirectives(_createVNode("select", {
                      value: "role",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => (_ctx.userput.role = $event)),
                      id: "role",
                      name: "role",
                      class: "modalcontent__input user-modalcontent__input"
                    }, [
                      _createVNode("option", _hoisted_54, _toDisplayString(_ctx.$t('admin.admin')), 1),
                      _createVNode("option", _hoisted_55, _toDisplayString(_ctx.$t('admin.guide')), 1),
                      _createVNode("option", _hoisted_56, _toDisplayString(_ctx.$t('admin.content_manger')), 1)
                    ], 512), [
                      [_vModelSelect, _ctx.userput.role]
                    ])
                  ]),
                  _createVNode("div", _hoisted_57, [
                    _createVNode("button", {
                      class: "button button--primary form__button form__button1",
                      onClick: _cache[18] || (_cache[18] = $event => (_ctx.changeUserById(_ctx.user1)))
                    }, _toDisplayString(_ctx.$t('admin.save')), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64 /* STABLE_FRAGMENT */))
}